const childRoutes = (prop) => [
    {
        path: 'organization-information-report',
        name: prop + '.organization_information_report',
        meta: { auth: true },
        component: () => import('../pages/organization-information-report/List.vue')
    },
    {
        path: 'published-circular-report',
        name: prop + '.published_circular_report',
        meta: { auth: true },
        component: () => import('../pages/published-circular-report/List.vue')
    },
    {
        path: 'trainee-attendance-report',
        name: prop + '.trainee_attendance_report',
        meta: { auth: true },
        component: () => import('../pages/trainee-attendance-report/List.vue')
    },
    {
        path: 'training-material-report',
        name: prop + '.training_material_report',
        meta: { auth: true },
        component: () => import('../pages/training-material-report/List.vue')
    },
    {
        path: 'events-awards-report',
        name: prop + '.events_awards_report',
        meta: { auth: true },
        component: () => import('../pages/events-awards-report/List.vue')
    },
    {
        path: 'trainee-info-report',
        name: prop + '.trainee_info_report',
        meta: { auth: true },
        component: () => import('../pages/trainee-info-report/List.vue')
    },
    {
        path: 'trainer-info-report',
        name: prop + '.trainer_info_report',
        meta: { auth: true },
        component: () => import('../pages/trainer-info-report/List.vue')
    },
    {
        path: 'trainee-evaluation-report',
        name: prop + '.trainee_evaluation_report',
        meta: { auth: true },
        component: () => import('../pages/trainee-evaluation-report/List.vue')
    },
    {
        path: 'trainer-evaluation-report',
        name: prop + '.trainer_evaluation_report',
        meta: { auth: true },
        component: () => import('../pages/trainer-evaluation-report/List.vue')
    },
  {
    path: 'tax-report',
    name: prop + '.tax_report',
    meta: { auth: true },
    component: () => import('../pages/trainer-tax-report/List.vue')
  },
    {
        path: 'fiscal-year-calendar-report',
        name: prop + '.fiscal_year_calendar_report',
        meta: { auth: true },
        component: () => import('../pages/fiscal-year-calendar-report/List.vue')
    },
    {
        path: 'trainer-honorarium-report',
        name: prop + '.trainer_honorarium_report',
        meta: { auth: true },
        component: () => import('../pages/trainer-honorarium-report/List.vue')
    },
    {
        path: 'trainee-allowance-report',
        name: prop + '.trainee_allowance_report',
        meta: { auth: true },
        component: () => import('../pages/trainee-allowance-report/List.vue')
    },
    {
        path: 'training-summary-report',
        name: prop + '.training_summary_report',
        meta: { auth: true },
        component: () => import('../pages/training-summary-report/List.vue')
    },
    {
        path: 'circular-wise-applicant-report',
        name: prop + '.circular_wise_applicant_report',
        meta: { auth: true },
        component: () => import('../pages/circular-wise-applicant-report/List.vue')
    }
]

const routes = [{
    path: '/training-e-learning-service/report-management',
    name: 'training_e_learning_service.report_management',
    component: () => import('@/layouts/TrainingElearningLayout.vue'),
    meta: { auth: true },
    children: childRoutes('training_e_learning_service.report_management')
}]

export default routes
